import { useLocalizedHref } from "@/libraries/web-framework";

import { SubNav } from "./subnav";

export interface RoadmapSubNavProps {
    className?: string;
}

export const RoadmapSubNav = ({ className }: RoadmapSubNavProps) => {
    const ROADMAP_NAV_CONFIG = {
        heading: {
            label: "Roadmaps",
            linkUrl: useLocalizedHref("/roadmap/cloud")
        },
        navItems: [
            {
                label: "Cloud",
                linkUrl: useLocalizedHref("/roadmap/cloud")
            },
            {
                label: "Data Center",
                linkUrl: useLocalizedHref("/roadmap/data-center")
            }
        ],
        cta: {
            label: "Explore how to migrate",
            linkUrl: "/migration"
        }
    } as const;
    return (
        <SubNav
            headingLabel={ROADMAP_NAV_CONFIG.heading.label}
            headingLinkUrl={ROADMAP_NAV_CONFIG.heading.linkUrl}
            navItems={ROADMAP_NAV_CONFIG.navItems.map((item) => ({
                label: item.label,
                linkUrl: item.linkUrl
            }))}
            cta={{
                label: ROADMAP_NAV_CONFIG.cta.label,
                linkUrl: ROADMAP_NAV_CONFIG.cta.linkUrl
            }}
            className={className}
        />
    );
};

RoadmapSubNav.displayName = "RoadmapSubNav";
